/**
 * Pass down the data structures to the <data-structure>
 * custom component in components/BlockMarkdown/DataStructure.js
 */
import React from 'react'

export default React.createContext({})
